import React, { useEffect, useState } from "react";
import { InstagramEmbed } from "react-social-media-embed";

const GOOGLE_SHEET_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vS7tzwXneXgPepoOWiRU84BSSd0CXmDMdLTrHDyDqpZpsEzyIxJPlCkqJFaJPHTrUhx8eHSjlofsNHQ/pub?output=csv";

const FeaturedBusinesses = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch(GOOGLE_SHEET_CSV_URL)
      .then((response) => response.text())
      .then((data) => {
        const urls = data.split("\n").map((row) => row.trim());
        setPosts(urls);
      })
      .catch((error) => console.error("Error fetching Instagram links:", error));
  }, []);

  return (
    <div className="max-w-6xl mx-auto py-10 px-4">
      <h2 className="text-3xl font-bold  mb-6 text-gray-800">
        Featured Businesses
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((url, index) => (
          <div key={index} className="flex justify-center">
            <InstagramEmbed url={url} width={328} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedBusinesses;
